import { Navigation, Navigator } from '@codeleap/web-navigation'
import { NextRouter } from 'next/router'

export const routes = {
  Home: '/',
  AccessHub: {
    Home: 'access-hub/home',
  },
  Profile: {
    Edit: 'profile/settings',
  },
  Auth: {
    Login: 'auth/login',
    Signup: 'auth/signup',
    ForgotPassword: 'auth/forgot',
    VerifyEmail: 'auth/verifyEmail',
  },
  About: 'about',
  Playground: 'playground',
  Components: {
    View: 'components/{{component}}',
    List: 'components',
    Navigation: {
      Home: 'components/Navigation',
      Page1: 'components/Navigation/page-1',
      Page2: 'components/Navigation/page-2/{{id}}',
    },
  },
  Crud: {
    Example: 'crud',
    View: 'crud/{{id}}',
  },
  Chat: {
    Chat: 'chat/list/',
  },
} as const

type NavigationContext = {
  router: NextRouter
  pathname: string
}

const navigator: Navigator<any, NavigationContext> = (path, options, ctx) => {
  if (ctx?.router) {
    ctx.router.push(path)
    return
  }

  throw new Error('Router not found in context')
}

export const navigation = new Navigation<{}, typeof routes, NavigationContext>(routes, navigator)

export const navigationEvents = {
  urlChange: 'urlchange',
}

export function navigateTo(path: string, queryParams: Record<string, string | undefined>, router?: NextRouter) {
  const searchParams = new URLSearchParams()
  Object.entries(queryParams).forEach(([key, value]) => {
    if (value) searchParams.set(key, value)
  })

  const targetPath = path.startsWith('/') ? path : `/${path}`
  const currentPath = window.location.pathname
  const isOnSamePage = currentPath === targetPath || currentPath === targetPath + '/' || currentPath + '/' === targetPath

  if (isOnSamePage) {
    const url = window.location.origin + targetPath + `?${searchParams.toString()}`
    window.history.pushState({ path: url }, '', url)
    window.dispatchEvent(new Event(navigationEvents.urlChange))
  } else {
    if (router) {
      router.push({
        pathname: targetPath,
        query: Object.fromEntries(searchParams),
      })
    } else {
      import('next/router').then(({ default: Router }) => {
        Router.push({
          pathname: targetPath,
          query: Object.fromEntries(searchParams),
        })
      })
    }
  }
}
